<template>
    <span></span>
</template>

<script>
import * as Actions from "./store/constants/actions";
import * as Mutations from "./store/constants/mutations";
import * as BusEvents from "./constants/bus-events";

export default {
    data() {
        return {};
    },
    created() {
        window.Bus.$on(BusEvents.UPDATE_USER, () => {
            this.$store.dispatch(Actions.UPDATE_USER);
        });
        window.Bus.$on(BusEvents.ORDER_REJECTED, (order) => {
            this.$store.commit(Mutations.REMOVE_PENDING_ORDER, order);
        });
        window.Bus.$on(BusEvents.ORDER_CANCELLED, (order) => {
            this.$store.commit(Mutations.REMOVE_PENDING_ORDER, order);
        });
    },
    methods: {},
};
</script>
